import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

interface IHttpRequest {
  post: <T = any>(url: string, model?: any) => Promise<AxiosResponse<T>>;
  get: <T = any>(url: string, responseType?: AxiosRequestConfig['responseType']) => Promise<AxiosResponse<T>>;
}

function HttpRequest(): IHttpRequest {

  const createConfig = (): AxiosRequestConfig => {
    const token = localStorage.getItem('token');
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    return { headers };
  };

  const post = <T = any>(url: string, model: any = {}): Promise<AxiosResponse<T>> => {
    const isFormData = model instanceof FormData;

    const config = createConfig();

    if (isFormData) {
      delete (config.headers ?? {})['Content-Type'];
    }

    return axios.post<T>(`${process.env.REACT_APP_API_ENDPOINT}${url}`, model, config);
  };

  const get = <T = any>(
    url: string,
    responseType: AxiosRequestConfig['responseType'] = 'json'
  ): Promise<AxiosResponse<T>> => {
    const baseConfig = createConfig();

    const config: AxiosRequestConfig = {
      ...baseConfig,
      responseType,
    };

    return axios.get<T>(`${process.env.REACT_APP_API_ENDPOINT}${url}`, config);
  };

  return {
    post,
    get,
  };
}

export default HttpRequest;
